"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
class Block extends React.Component {
    render() {
        const { Component, props } = this.props;
        return (React.createElement("div", null,
            React.createElement(Component, Object.assign({}, props))));
    }
}
exports.Block = Block;



// WEBPACK FOOTER //
// ./src/core/base/Block.tsx